export default __webpack_public_path__ + "static/media/leoniger.57669f67.png";